export default "__VITE_ASSET__OpDSLwzO__"